import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

interface VideoCardProps {
  id: string;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: string;
  date: string;
}

export default function VideoCard({ id, title, category, thumbnail, duration, views, date }: VideoCardProps) {
  const catInfo = categories.find(c => c.slug === category);

  return (
    <div className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer">
      <div className="relative aspect-video overflow-hidden">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
        <span className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
          {duration}
        </span>
        {catInfo && (
          <Link
            to={`/category/${catInfo.slug}`}
            className="absolute top-2 left-2 bg-white/90 text-foreground-800 text-xs px-2 py-0.5 rounded-full whitespace-nowrap no-underline hover:bg-primary-100 transition-colors"
            onClick={(e) => e.stopPropagation()}
          >
            {catInfo.name}
          </Link>
        )}
      </div>
      <div className="p-4">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors font-heading">
          {title}
        </h3>
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {views}
          </span>
          <span>{date}</span>
        </div>
      </div>
    </div>
  );
}